import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Chip } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  container: {
	paddingTop: 12,
    flex: 1
  },
  count: {
    paddingLeft: 5,
    paddingRight: 5,
    fontSize: 18,
	fontFamily: 'Roboto Medium',
	lineHeight: '32px',
  },
  chipContainer: {
    // paddingLeft: 20,
	display: 'flex',
	justifyContent: 'center',
    flex: 1,
    paddingTop: 4
  },
  countLabel: {
	color: 'rgba(0, 0, 0, 0.54)',
    textAlign: 'center',
    fontSize: 16,
    fontFamily: 'Roboto Medium',
    borderBottom: '1px solid #323232',
    marginBottom: 8,
    paddingBottom: 4
  },
  countButton: {
    fontSize: 32,
    minWidth: 44
  }
}));

export default props => {
  const { id, count, onClick, label } = props;
  const classes = useStyles();

  const handleAddClick = () => {
    let temp = count + 1;
    onClick(id, temp);
  };

  const handleRemoveClick = () => {
    let temp = count - 1;
    if (temp > -1) {
      onClick(id, temp);
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.countLabel}>{label}</div>
      <span className={classes.chipContainer}>
        <Chip
          className={classes.countButton}
          disabled={count === 0}
          variant="outlined"
          label={'-'}
          onClick={handleRemoveClick}
        />
        <span className={classes.count}>{count}</span>
        <Chip
          className={classes.countButton}
          variant="outlined"
          label={'+'}
          onClick={handleAddClick}
        />
      </span>
    </div>
  );
};
